import classNames from 'classnames';

type Props = {
    className: string;
    gridcolstablet?: string;
    gridcolsdesktop?: string;
};

const CardContainer = ({
    children,
    className,
    gridcolstablet = '2',
    gridcolsdesktop = '2',
}: React.PropsWithChildren<Props>) => {
    return (
        <div
            className={classNames(
                'grid gap-4 gap-y-16 pt-20',
                `md:grid-cols-${gridcolstablet} lg:grid-cols-${gridcolsdesktop}`,
                className
            )}
        >
            {children}
        </div>
    );
};

export default CardContainer;
